import React, { useState, useEffect } from 'react';
import { Form, Button, Col, Row, Card, Alert, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import PhoneInput from '../Input/PhoneInput'
import { useProvider, Toast, isNative } from '../../context/MenuProvider'


const Registro = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [nomeUsuario, setNomeUsuario] = useState('');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [funcoes, setFuncoes] = useState([]);
  const [formErrors, setFormErrors] = useState({}); // Estado para erros de validação de campo
  const {
    crud,
    excluirDadosCompleto,
    salvarDados,
  }=useProvider();
  const { loading, error: apiError, post, get } = crud || {}
  
  
  useEffect(()=>{
      const carregarConfiguracoes = async()=>{
        try{
          const url = [
            `/core/grupos/?filtros=id,name&ordering=name`,
          ]
          const response = await get(url,'configuracoes');
          //alert(JSON.stringify(response[0].results[0]))
          if(response && response.length){
            const listaGrupos = response[0].results;
            setFuncoes(listaGrupos);
          }
        }catch(err){
        }
        finally{
          await excluirDadosCompleto();
        }
      }
      carregarConfiguracoes();
  }, [])
  
  const handleSubmit = async (event) => {
    event.preventDefault();
    let errors = {}; // Objeto para armazenar erros de campo

    // Validação dos campos
    if (name === '') errors.name = 'Por favor, informe o nome do seu negócio.';
    if (email === '') errors.email = 'Por favor, informe o email.';
    if (senha === '') errors.senha = 'Por favor, informe a senha.';
    if (confirmPassword === '') errors.confirma_senha = 'Por favor, confirme a senha.';
    if (phone === '') errors.telefone_whatsapp = 'Por favor, informe o WhatsApp.';
    if (phone.replace(/\D/g, "").length > 0 && phone.replace(/\D/g, "").length !== 11) errors.telefone_whatsapp = 'WhatsApp inválido, informe 11 dígitos';
    if (senha !== confirmPassword) errors.passwordMatch = 'As senhas não coincidem.';
    const grupo_ids = funcoes.filter(x => x.checked).map(x => x.id);
    if (parseInt(grupo_ids?.length || 0) === 0) errors.funcoes = 'Por favor, selecione as funções que deseja usar.';

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors); // Se houver erros, atualize o estado
      return;
    }

    // Limpa os erros antes de enviar os dados
    setFormErrors({});

    const registerData = {
      "nome_proprietario": name,
      "nome_da_loja": name,
      "telefone_whatsapp": phone,
      "email": email,
      "senha": senha,
      "confirma_senha": confirmPassword,
      "funcoes": grupo_ids,
    }
    
    //alert(JSON.stringify(registerData))
    try{
      const response = await post(registerData, `/gvendas/empresas/`, null, 'registrar', false);
      if (response && response?.length){
        const loginData = { 
          'username':email, 
          'password':senha 
        };
        const loginResult = await post(loginData, `/api/token/`, null, 'login', false); // Executando requisição
        if(loginResult && loginResult?.length){
          await excluirDadosCompleto();
          await salvarDados('local_registros', {
            ...loginResult[0],
            id:"auth"
          });
          if(isNative) window.dispatchNativeMessage("login");
          if(!isNative) navigator.serviceWorker.controller.postMessage('login');
        }else {
          navigate('/');
        }
        Toast.fire({
            icon: "success",
            title: "Registrado com sucesso"
        });
      }
    }catch(err){
        console.error("Erro ao criar conta:", err);
        
        const errorMessage = typeof err.response?.data === 'string' ? 'Erro desconhecido ao criar a conta.' : err.response?.data?.detail;
        setFormErrors(prevErrors => ({
          ...prevErrors,
          ...err.response?.data,
          apiError: errorMessage,
        }));
        //alert(JSON.stringify(err.response))
        //alert(JSON.stringify(err))
        Toast.fire({
          icon: "warning",
          title: "Não foi registrado"
        });
    }finally{
      
    }
  };

  return (
    <div>
      <Card>
        <Card.Body>
          <h5 className="text-center border-dashed-bottom mb-4">Seu negócio</h5>
          <Form onSubmit={handleSubmit}>
            {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}
            <Form.Group controlId="name" className="mb-3">
              <Form.Label>Nome do seu negócio*</Form.Label>
              <Form.Control
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Nome do seu negócio"
              />
              {formErrors.nome_da_loja && <Alert variant="danger">{formErrors.nome_da_loja}</Alert>}
            </Form.Group>
            
            <PhoneInput phone={phone} setPhone={setPhone} formErrors={formErrors} is_obrigatorio={true} placeholder={"WhatsApp do seu negócio"}/>
    
            <h5 className="text-center border-dashed-bottom mb-4">Dados de acesso</h5>
            
            <Form.Group controlId="email" className="mb-3">
              <Form.Label>Email*</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
              />
              {formErrors.email && <Alert variant="danger">{formErrors.email}</Alert>}
            </Form.Group>
    
            <Form.Group controlId="senha" className="mb-3">
              <Form.Label>Senha*</Form.Label>
              <Form.Control
                type="password"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                placeholder="Senha de acesso"
              />
              {formErrors.senha && <Alert variant="danger">{formErrors.senha}</Alert>}
            </Form.Group>
    
            <Form.Group controlId="confirmPassword" className="mb-3">
              <Form.Label>Confirmar senha*</Form.Label>
              <Form.Control
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirme a senha de acesso"
              />
              {formErrors.confirma_senha && <Alert variant="danger">{formErrors.confirma_senha}</Alert>}
              {formErrors.passwordMatch && <Alert variant="danger">{formErrors.passwordMatch}</Alert>}
            </Form.Group>
    
            <h5 className="text-center border-dashed-bottom mb-4">Funções do App</h5>
            <div className="table-responsive">
              {formErrors.funcoes && <Alert variant="danger">{formErrors.funcoes}</Alert>}
              <Table className="table table-bordered">
                <tbody>
                  {funcoes.map((item, index) => (
                    <tr className="text-center">
                      <td scope="col">
                        <Row>
                          <Col>
                            <Form.Group controlId={`group_${index}`}>
                              <Form.Check
                                type="switch"
                                label={item.name}
                                checked={item.checked}
                                onChange={(e) =>
                                  setFuncoes((prev) =>
                                    prev.map((g) =>
                                      g.id === item.id ? { ...g, checked: e.target.checked } : g
                                    )
                                  )
                                }
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            
            <Button variant="secondary" type="submit" className=" w-100" disabled={loading}>
              Criar conta
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Registro;